import React from 'react';
import Icon from '../AppIcon';

const StatusNotificationBadge = ({ count = 0, type = 'info', label = 'Notifications', onClick }) => {
  if (count === 0) return null;

  const getIconAndColor = () => {
    switch (type) {
      case 'success':
        return { icon: 'CheckCircle2', color: 'var(--color-success)' };
      case 'warning':
        return { icon: 'AlertCircle', color: 'var(--color-warning)' };
      case 'error':
        return { icon: 'XCircle', color: 'var(--color-error)' };
      default:
        return { icon: 'Bell', color: 'var(--color-primary)' };
    }
  };

  const { icon, color } = getIconAndColor();

  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 px-3 py-1.5 bg-muted rounded-full text-caption transition-smooth hover:bg-muted/80 active-press"
      aria-label={`${count} ${label}`}
    >
      <Icon name={icon} size={16} color={color} />
      <span className="font-semibold text-data" style={{ color }}>
        {count}
      </span>
      <span className="text-muted-foreground hidden sm:inline">{label}</span>
    </button>
  );
};

export default StatusNotificationBadge;